import * as client_hooks from '../../../src/hooks.client.js';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103')
];

export const server_loads = [0,9,2,13,14,15];

export const dictionary = {
		"/(marketing)/(with-header)": [70,[9,11]],
		"/(marketing)/(with-header)/about": [71,[9,11]],
		"/(admin)/account/me": [~16,[2,3,4]],
		"/(admin)/account/me/danger": [17,[2,3,4]],
		"/(admin)/account/me/security": [18,[2,3,4]],
		"/(admin)/appsumo-activation": [19,[2]],
		"/(marketing)/(with-header)/blog": [~72,[9,11]],
		"/(marketing)/(with-header)/blog/[slug]": [~73,[9,11]],
		"/(admin)/brand/[teamSlug]/(menu)": [~20,[2,5]],
		"/(admin)/brand/[teamSlug]/api": [57,[2]],
		"/(admin)/brand/[teamSlug]/(menu)/competitions/[id]": [~21,[2,5]],
		"/(admin)/brand/[teamSlug]/competitions/[id]/edit": [~58,[2]],
		"/(admin)/brand/[teamSlug]/(menu)/finish-upgrading": [22,[2,5]],
		"/(admin)/brand/[teamSlug]/(menu)/settings": [23,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/billing": [~24,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations": [~25,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/activecampaign": [~26,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/acumbamail": [~27,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/aweber": [~28,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/beehiiv": [~29,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/benchmark": [~30,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/campaignmonitor": [~31,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/drip": [~32,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/getresponse": [~33,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/googlesheets": [~34,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/hubspot": [~35,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/keap": [~36,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/kit": [~37,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/klaviyo": [~38,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/mailchimp": [~39,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/mailerlite": [~40,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/mailjet": [~41,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/omnisend": [~42,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/pabbly": [~43,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/sendfox": [~44,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/sendgrid": [~45,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/sendy": [~46,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/shopify": [~47,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/swipeone": [~48,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/useinbox": [~49,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/vbout": [~50,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/webhooks": [~51,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/integrations/zapier": [52,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/members": [~53,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/settings/usage": [~54,[2,5,6]],
		"/(admin)/brand/[teamSlug]/(menu)/templates": [~55,[2,5]],
		"/(admin)/brand/[teamSlug]/(menu)/users": [~56,[2,5]],
		"/(marketing)/(with-header)/changelog": [74,[9,11]],
		"/checkout/success": [96],
		"/connect/integrations/shopify": [~97,[13]],
		"/(marketing)/(with-header)/customers": [75,[9,11]],
		"/(giveaway)/c/[slug]": [~60,[8]],
		"/(giveaway)/c/[slug]/embed": [~61,[8]],
		"/(giveaway)/c/[slug]/terms-and-conditions": [~62,[8]],
		"/data-deletion": [98],
		"/data-deletion/status": [99],
		"/(giveaway)/demo/[slug]": [~63],
		"/(marketing)/(with-header)/dice-roller": [76,[9,11]],
		"/(marketing)/features": [94,[9]],
		"/(marketing)/(auth)/forgot-password": [66,[9,10]],
		"/(marketing)/(with-header)/giveaways": [~78,[9,11]],
		"/(marketing)/(with-header)/giveaways/[slug]": [~79,[9,11]],
		"/(marketing)/(with-header)/giveaway": [~77,[9,11]],
		"/(marketing)/(with-header)/guides": [~80,[9,11]],
		"/(marketing)/(with-header)/guides/[slug]": [~81,[9,11]],
		"/(marketing)/(with-header)/instagram-comment-picker": [82,[9,11]],
		"/(marketing)/(with-header)/integrations": [83,[9,11]],
		"/(marketing)/invite/[id]": [~95,[9]],
		"/(marketing)/(with-header)/ltd-thank-you": [85,[9,11]],
		"/(marketing)/(with-header)/ltd": [84,[9,11]],
		"/oauth/appsumo": [~100,[14]],
		"/(admin)/onboarding": [59,[2,7]],
		"/(giveaway)/preview/[domain]": [~64],
		"/(marketing)/(with-header)/pricing": [86,[9,11]],
		"/(marketing)/(with-header)/privacy": [87,[9,11]],
		"/(marketing)/(with-header)/random-name-picker": [88,[9,11]],
		"/redirect": [101],
		"/(marketing)/(auth)/sign-in": [67,[9,10]],
		"/sign-out": [~102],
		"/(marketing)/(auth)/sign-up": [68,[9,10]],
		"/sso/featurebase": [103,[15]],
		"/(marketing)/(with-header)/support": [89,[9,11]],
		"/(marketing)/(with-header)/sweepstakes-rules-generator": [90,[9,11]],
		"/(marketing)/(with-header)/templates": [~91,[9,11]],
		"/(marketing)/(with-header)/templates/[slug]": [~92,[9,11]],
		"/(giveaway)/templates/[slug]/preview": [~65],
		"/(marketing)/(with-header)/terms": [93,[9,11]],
		"/(marketing)/(auth)/update-password": [69,[9,10]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';